module.exports = __webpack_public_path__ + "media/images/re/joshua-hanks-659912-unsplash-8d27e86d1620cb5d4e6812154bd9ce0f.png";